module.exports = __webpack_public_path__ + "img/mbanner2.c6b5bc33.jpg";